import axios from 'axios';
import { MainUrl } from "../constants"

const API_URL = `${MainUrl}/restaurant`


export const RestaurantGet = async (token, restaurantId) => {

  const response = await axios.get(`${API_URL}/${restaurantId}`, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
  return response.data;
};

export const GetAcativeRestaurants = async (token, page, limit) => {
  try {
    const response = await axios.get(`${API_URL}/active/`, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
  return response.data;
  }
  catch(error) {
    if (error.response.status == 401){
      window.location.href = '/';
    }
  }
};

export const GetRestaurants = async (token, page, limit) => {
  try {
    const response = await axios.post(`${API_URL}/restaurants?page=${page}&limit=${limit}`, {}, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
  return response.data;
  }
  catch(error) {
    if (error.response.status == 401){
      window.location.href = '/';
    }
  }
};

export const CreateRestaurant = async (token, {name, is_active, bk_name, area_id, description}) => {
  
  const body = {name, is_active, bk_name, area_id, description}
  console.log(body)
  const response = await axios.post(`${API_URL}/`, body, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
  return response.data;
};


export const DeleteRestaurant = async (token, id) => {
  
  const response = await axios.delete(`${API_URL}/${id}`, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
  return response.data;
};

export const UpdateRestaurant = async (token, {id, name, is_active, bk_name, area_id, description, c_name}) => {
try {
  const body = {name, is_active, bk_name, area_id, description, c_name}
  const response = await axios.patch(`${API_URL}/${id}`, body, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
  return response.data;
}
catch(error){
  return error.response
}

}